import { NetworkParameters } from 'src/modules/types/interfaces';

export class FetchBlacklistedNetworkParameters {
static readonly type = '[blacklisted-networks] Fetch All';

constructor(public payload: NetworkParameters[]){}

}
